module.exports = __webpack_public_path__ + "static/media/marketing.eb181092.svg";